import * as React from 'react';

import AuthService from '../../global/authService';

import LoginForm from '../components/login-form';
import {getCredentials} from "../utils/getCredentials";
import {removeJWTToken} from "../utils/getJWTToken";
/**
 * This component renders a faux authentication UI
 *
 * It prompts for the username/password (and gives hints with bouncy arrows)
 * It shows errors if the authentication failed for any reason.
 *
 * The `login` method validates the credentials.
 * Then it sends the user back to the `returnTo` state, which is provided as a resolve data.
 */
export class Login extends React.Component<any> {
    usernames: any;
    constructor (props: any) {
        super(props);
        this.usernames = AuthService.usernames;
        this.state = {
            username: '',
            password: '',
            authenticating: false,
            errorMessage: ''
        }
    }
    handleChangeCredentials = (credentials: any) => {
        this.setState(credentials);
    }
    handleLogin = (c: {username: string, password: string}) => {
        const credentials = getCredentials(c);
        let {transition, returnTo} = this.props;
        const done = () => this.setState({authenticating:false});
        const showError = (errorMessage: string) => this.setState({errorMessage});
        const returnToOriginalState = () => transition.router.stateService.go(returnTo.state(), returnTo.params(), { reload: true });
        removeJWTToken();
        this.setState({authenticating:true});
        AuthService.authenticate(credentials.username, credentials.password)
            .then(returnToOriginalState)
            .catch((error) => {
                done();
                console.error(error);
                showError('Authentication Failed');
            });
    }
    render () {
        let {errorMessage, authenticating, username, password}: any = this.state;
        return (
            <div className="container">
                <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                    <h3>Log In</h3>
                    <hr/>
                    <LoginForm
                        usernameOptions={this.usernames}
                        username={username}
                        password={password}
                        error={errorMessage}
                        loading={authenticating}
                        onChangeValues={this.handleChangeCredentials}
                        onSubmit={this.handleLogin}
                    />
                </div>
            </div>
        );
    }
}
